module.exports = __webpack_public_path__ + "static/media/phoneLogo.e74d2b95.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Videos/medias/phoneLogo.mp4
// module id = 126
// module chunks = 0